import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { Phase, WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

export const getActivePhaseIsReactiveScope = (
  wir: WIR | null,
  phase: Phase,
  countryState: string,
) => {
  {/* istanbul ignore next */}
  if (countryState === CountryData.denmark) {
    return (
      /* istanbul ignore next */
      getIsUnplannedReactiveScope(wir) &&
      /* istanbul ignore next */
      phase !== WIRCreateJourneyStepsKeys.STAGE_GATE_4 &&
      /* istanbul ignore next */
      phase !== WIRCreateJourneyStepsKeys.STAGE_GATE_5
    );
  /* istanbul ignore next */
  } else if (countryState === CountryData.nigeria) {
    return (
      /* istanbul ignore next */
      getIsUnplannedReactiveScope(wir) &&
      /* istanbul ignore next */
      phase !== WIRCreateJourneyStepsKeys.NG_INTERVENTION_OPERATION &&
      /* istanbul ignore next */
      phase !== WIRCreateJourneyStepsKeys.NG_INTERVENTION_CLOSE_OUT
    );
  } else if (countryState === CountryData.congo) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.CG_INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.CG_INTERVENTION_CLOSE_OUT
    );
  } else if (countryState === CountryData.angola) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      /* istanbul ignore next */
      phase !== WIRCreateJourneyStepsKeys.AG_INTERVENTION_OPERATION &&
      /* istanbul ignore next */
      phase !== WIRCreateJourneyStepsKeys.AG_INTERVENTION_CLOSE_OUT
    );
  /* istanbul ignore next */
  } else if (countryState === CountryData.iraq) {
    return (
      /* istanbul ignore next */
      getIsUnplannedReactiveScope(wir) &&
      /* istanbul ignore next */
      phase !== WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_OPERATION &&
      /* istanbul ignore next */
      phase !== WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_CLOSE_OUT
    );
  } else if (countryState === CountryData.argentina) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_CLOSE_OUT
    );
  } else {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.INTERVENTION_CLOSE_OUT
    );
  }
};
